var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#E94435;}\r\n\t.st2{fill:#F8BB15;}\r\n\t.st3{fill:#547DBE;}\r\n\t.st4{fill:#34A751;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st0",
    d: "M195.2,81.2c-43.5,14.9-80.6,47.5-101.2,88.6c-7.2,14.2-12.4,29.3-15.5,44.9 c-7.9,38.8-2.4,80.1,15.5,115.5c11.6,23.1,28.3,43.6,48.5,59.6c19.1,15.2,41.3,26.4,64.9,32.7c29.7,8,61.4,7.8,91.4,1 c27.1-6.2,52.7-19.2,73.1-38c21.6-19.9,37-46,45.2-74.1c8.9-30.7,10.1-63.4,4.5-94.8c-56,0-112,0-168.1,0c0,23.2,0,46.5,0,69.7 c32.4,0,64.9,0,97.3,0c-3.8,22.3-17,42.6-35.8,55.2c-11.8,7.9-25.3,13.1-39.3,15.5c-14.1,2.4-28.6,2.7-42.6-0.1 c-14.3-2.8-27.9-8.8-39.8-17.2c-19-13.3-33.5-32.9-40.9-54.8c-7.6-22.3-7.7-47.2,0-69.5c5.3-15.7,14.2-30.3,25.9-42.1 c14.4-14.8,33.1-25.3,53.3-29.6c17.3-3.7,35.5-3,52.4,2.1c14.4,4.4,27.6,12.2,38.5,22.6c11-10.9,21.9-21.9,32.9-32.8 c5.7-5.9,11.8-11.5,17.4-17.6c-16.6-15.4-36.2-27.8-57.5-35.6C277.1,68.1,233.8,67.8,195.2,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st1",
    d: "M195.2,81.2c38.6-13.4,81.9-13.1,120.3,1.1c21.3,7.8,40.8,20.2,57.5,35.6 c-5.6,6-11.6,11.7-17.4,17.6c-11,10.9-21.9,21.9-32.9,32.8c-10.9-10.4-24.1-18.3-38.5-22.6c-16.9-5.1-35.1-5.8-52.4-2.1 c-20.2,4.3-38.9,14.9-53.3,29.6c-11.7,11.8-20.6,26.4-25.9,42.1c-19.5-15.1-39-30.3-58.5-45.4C114.6,128.7,151.7,96.1,195.2,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st2",
    d: "M78.5,214.7c3.1-15.6,8.4-30.7,15.5-44.9c19.5,15.1,39,30.3,58.5,45.4 c-7.7,22.3-7.6,47.2,0,69.5c-19.5,15.1-39,30.3-58.5,45.4C76.1,294.9,70.6,253.5,78.5,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st3",
    d: "M253.6,216.5c56,0,112,0,168.1,0c5.6,31.4,4.4,64.1-4.5,94.8c-8.2,28.1-23.6,54.3-45.2,74.1 c-18.9-14.7-37.9-29.4-56.7-44.1c18.8-12.5,32-32.9,35.8-55.2c-32.4,0-64.9,0-97.3,0C253.5,263,253.6,239.8,253.6,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st4",
    d: "M94,330.2c19.5-15.1,39-30.3,58.5-45.4c7.4,22,21.9,41.5,40.9,54.8 c11.9,8.4,25.5,14.3,39.8,17.2c14,2.8,28.6,2.5,42.6,0.1c14-2.4,27.5-7.6,39.3-15.5c18.9,14.7,37.9,29.4,56.7,44.1 c-20.4,18.9-46,31.8-73.1,38c-29.9,6.8-61.6,7-91.4-1c-23.6-6.3-45.8-17.5-64.9-32.7C122.3,373.7,105.6,353.2,94,330.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.764b65c6c84da7afeba3e858a7c90544.svg";
export { ForwardRef as ReactComponent };